<template>
  <div class="product-wrapper">
    <div class="product-row" :class="{ 'split-mode': rozdilit }">
      <!-- Ліва частина: чекбокс + назва -->
      <div class="product-left">
        <!--  -->
        <label class="custom-checkbox" v-if="rozdilit">
          <input
            type="checkbox"
            @change="changeIsProduct"
            v-model="currentProduct.is"
          />
          <span class="checkmark"></span>
        </label>
        <transition name="fade-text" mode="out-in">
          <div class="product-info" :key="rozdilit ? 'split' : 'normal'">
            <span class="product-name" :class="{ multiline: rozdilit }">
              {{ product.nomenclatureName }}
            </span>

            <transition name="fade-scale">
              <div
                v-if="
                  rozdilit &&
                  product.count > 1 &&
                  currentProduct &&
                  currentProduct.is
                "
                class="product-count-c"
              >
                <button
                  class="btn_count"
                  :disabled="currentProduct.count <= 1"
                  @click="decreaseCount"
                >
                  -
                </button>
                <div>{{ currentProduct.count }}</div>
                <button
                  class="btn_count"
                  :disabled="currentProduct.count >= product.count"
                  @click="increaseCount"
                >
                  +
                </button>
              </div>
              <div v-else class="product-count-c-empty"></div>
            </transition>
          </div>
        </transition>
      </div>
      <!-- Права частина: x+ ціна -->
      <div class="product-right">
        <span class="product-count">x{{ product.count }}</span>
        <p class="price">{{ formatPrice(product.price) }} ₴</p>
      </div>
    </div>

    <!-- Модифікатори -->
    <template v-if="product.additionally && product.additionally.length">
      <div v-for="modif in product.additionally" :key="modif.nomenclatureId">
        <div class="modif-line">
          + x{{ modif.count }} {{ modif.nomenclatureName }} {{ modif.price }}₴
        </div>
      </div>
    </template>

    <hr class="between-goods" />
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);

export default {
  props: ["product", "rozdilit", "productsForRozdilit", "productKey"],
  data() {
    return {
      render: false,
    };
  },
  methods: {
    formatPrice(price) {
      return Number(price).toFixed(2);
    },
    changeIsProduct() {
      this.render = !this.render;
    },
    decreaseCount() {
      if (this.currentProduct.count > 1) {
        this.currentProduct.count--;
        this.changeIsProduct();
      }
    },
    increaseCount() {
      if (this.currentProduct.count < this.product.count) {
        this.currentProduct.count++;
        this.changeIsProduct();
      }
    },
  },
  computed: {
    currentProduct() {
      return this.productsForRozdilit[this.productKey] || null;
    },
  },
};
</script>

<style scoped>
.product-wrapper {
  padding: 3px 0;
}

.product-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  transition: all 0.3s ease;
}

.product-left {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex: 1;
}

.product-info {
  display: flex;
  /* flex-direction: column; */
  gap: 6px;
  /* max-width: 180px; */

  flex-direction: row;
  /* align-items: center; */
  justify-content: space-between;
  gap: 6px;
  flex: 1 180px;
}

.product-name {
  /* white-space: nowrap; */
  transition: all 0.3s ease;
}

.product-name.multiline {
  white-space: normal;
  line-height: 1.3;
}

.product-count-c {
  display: flex;
  align-items: center;
  /* border: 1px solid #e5e5e5; */
  gap: 8px;
  padding: 4px 10px;
  border-radius: 12.5px;
  height: 25px;
  background-color: #f9f9f9;
}
.product-count-c-empty {
  /* min-width: 61px; */
}

.btn_count {
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 0 5px;
  color: rgb(208, 208, 208);
}

.product-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
  white-space: nowrap;
  min-width: 70px;
}

.product-count {
  opacity: 0.5;
}

.price {
  font-weight: bold;
  font-size: 16px;
}

.modif-line {
  opacity: 0.5;
  font-size: 12px;
  text-align: right;
  margin-left: 10px;
}

/* Анімації */
.fade-text-enter-active,
.fade-text-leave-active {
  transition: all 0.3s ease;
}
.fade-text-enter,
.fade-text-leave-to {
  opacity: 0;
  transform: translateY(-5px);
  /* background-color: green; */
}

.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.25s ease;
}
.fade-scale-enter,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

.custom-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  width: 24px;
  height: 24px;
}

.custom-checkbox input[type="checkbox"] {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.custom-checkbox .checkmark {
  width: 100%;
  height: 100%;
  background-color: #eee;
  border-radius: 5px;
  transition: 0.2s ease-in-out;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-checkbox input:checked + .checkmark {
  background-color: #49b461;
  border-color: #49b461;
}

.custom-checkbox .checkmark::after {
  content: "";
  display: none;
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) translateY(-1px);
}

.custom-checkbox input:checked + .checkmark::after {
  display: block;
}
</style>
